<div class="card">
  <div class="row align-items-center">
    <div class="col-12 col-sm-12 text-center">
      <strong>{{'screen.seatsSelectedList.label' | translate}}:</strong>
      <span *ngFor="let seat of seatsSelected">{{seat.rowSymbol}}{{seat.colNumber}}</span>
    </div>
  </div>
</div>

